ApiAjax = require 'app/scripts/network/api-ajax'
Auth = require 'app/scripts/db/auth'
CollectionWithHelpers = require 'app/scripts/models/collections/internal/collection-with-helpers'
Member = require 'app/scripts/models/member'

class MemberList extends CollectionWithHelpers
  model: Member
  sortField: 'fullName'

  idList: -> @pluck('id')

  removeMembership: (member, options) ->
    @remove(member)

    if !@sourceModel?
      return

    route =
      if options?.invite
        "/1/#{ @sourceModel.typeName }/#{ @sourceModel.id }/ghost/#{ member.id }"
      else
        "/1/#{ @sourceModel.typeName }/#{ @sourceModel.id }/members/#{ member.id }"
    if options?.mass
      route += "/all"
    ApiAjax
      url: route
      type: 'delete'
      success: (resp) ->
        # This isn't actually a successful response. For some reason, if
        # an error occurs while removing a member, the server will send
        # a 200 with a response of {unreadable:true}. Why is this different
        # from everything else in the API? I don't know. But it should be
        # treated like an error case, and since we're not handling errors
        # here properly anyway, I'm just going to ignore it.
        if resp?.unreadable
          return
        options?.success?()

  # Returns a new member list without members that you shouldn't be able to see
  # The force option excludes deactivated members, even if you're allowed to
  # see them
  filterDeactivated: ({ model, force } = {}) ->
    model ?= @sourceModel
    force ?= false
    # We don't want to always use @options.model, since that could be a card and
    # we want to reference the membership model (board in that case)
    # force allows you to forget whether the user can see them or not
    me = Auth.me()
    new MemberList(@filter (member) ->
      # Make sure the member is on the model since you could somehow be on a
      # card without being on the board (since removal was broken for some
      # time), and we don't want to hide that member while they wonder why
      # they're getting updates.
      (model.hasActiveMembership(member) ||
        (!force && model.isDeactivated(member) && model.canSeeDeactivated(me)))
    , @options)

  comparator: (member) ->
    member.get(@sortField)?.toLocaleLowerCase()

module.exports = MemberList
